module.exports = __webpack_public_path__ + "static/img/pedro-lastra-Nyvq2juw4_o-unsplash.acb33db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pedro-lastra-Nyvq2juw4_o-unsplash.png
// module id = Gwt6
// module chunks = 1